import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllFamilias } from '../../../Services/familiaService'

const usePagination = (history, isActive = true) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [isLoad, setIsLoad] = useState(true)
    const [familias, setFamilias] = useState([])

    //Pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const lastSearchRef = useRef('')

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllFamilias(isActive, 0, query)
                .then((res) => {
                    setFamilias(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                })
                .catch((error) => console.log(error.response))
        } else {
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllFamilias(isActive, page + 1, query)
            .then((res) => {
                setPage(page + 1)
                setFamilias(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllFamilias(isActive, page - 1, query)
            .then((res) => {
                setPage(page - 1)
                setFamilias(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }
    const handleBuscador = (e) => {
        setQuery(e.target.value)
        if (e.key === 'Enter') {
            const trimmedValue = e.target.value.trim()

            if (trimmedValue === '' && lastSearchRef.current !== '') {
                getAllFamilias(isActive, 0, '')
                    .then((res) => {
                        setPage(0)
                        setFamilias(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = '' // Se actualiza la referencia al estado vacío
                    })
                    .catch((err) => console.log('error'))
            }

            // Si hay contenido y es diferente a la última búsqueda, hace una nueva búsqueda
            else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {
                getAllFamilias(isActive, 0, trimmedValue)
                    .then((res) => {
                        setPage(0)
                        setFamilias(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = trimmedValue //Actualizo la referencia a la busqueda actual
                    })
                    .catch((err) => console.log('error'))
            }
            // En cualquier otro caso (input vacío sin búsqueda previa, o misma búsqueda) no hacer nada
        }
    }

    return {
        handleBuscador,
        nextPage,
        previousPage,
        totalRegister,
        totalPage,
        page,
        familias,
        setIsLoad,
    }
}

export default usePagination
